import React, { Component } from 'react';
import './ImageScrubber.css';
import {
    getViewBindingSnapshot,
    resolveViewIndex
} from './imageViewBindings';

class ImageScrubber extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentIndex: 0,
            fading: false
        };
        this.goTo = this.goTo.bind(this);
    }

    componentDidUpdate(prevProps) {
        const { configuration, viewBindings, defaultViewIndex = 0 } = this.props;
        const prevSnapshot = getViewBindingSnapshot(
            prevProps.configuration,
            viewBindings
        );
        const nextSnapshot = getViewBindingSnapshot(configuration, viewBindings);

        if (!viewBindings || prevSnapshot === nextSnapshot) {
            return;
        }

        const nextIndex = resolveViewIndex(
            configuration,
            viewBindings,
            defaultViewIndex
        );

        if (nextIndex !== this.state.currentIndex) {
            this.goTo(nextIndex);
        }
    }

    goTo(index) {
        if (index === this.state.currentIndex || this.state.fading) return;
        this.setState({ fading: true }, () => {
            setTimeout(() => {
                this.setState({ currentIndex: index, fading: false });
            }, 220);
        });
    }

    render() {
        const { images } = this.props;
        const { currentIndex, fading } = this.state;

        if (!images || images.length === 0) return null;
        if (images.length === 1) return images[0];

        const total = images.length;
        const prevIndex = (currentIndex - 1 + total) % total;
        const nextIndex = (currentIndex + 1) % total;

        return (
            <div className="imageScrubber">
                <div className={`imageScrubberContent${fading ? ' fading' : ''}`}>
                    {images[currentIndex]}
                </div>
                <div className="imageScrubberNav">
                    <button
                        className="imageScrubberBtn"
                        onClick={() => this.goTo(prevIndex)}
                        aria-label="Previous image"
                    >
                        &#9664;
                    </button>
                    <span className="imageScrubberIndicator">
                        {currentIndex + 1}/{total}
                    </span>
                    <button
                        className="imageScrubberBtn"
                        onClick={() => this.goTo(nextIndex)}
                        aria-label="Next image"
                    >
                        &#9654;
                    </button>
                </div>
            </div>
        );
    }
}

export default ImageScrubber;



// WEBPACK FOOTER //
// ./src/ImageScrubber.js